import type { Config } from './types'

const config: Config = {
  verbose: false,
  interpolationsPerSplineSegment: 100,
  layers: [],
}

export default config

